<template>
  <div class="relative min-h-screen">
    <section
      class="flex flex-col items-center pt-8 pb-6"
      v-if="!isFirst && rating"
    >
      <p class="text-3xl">Area Overall Cop Average:</p>
      <div class="relative text-center mt-8">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="180"
          height="180"
          viewBox="0 0 24 24"
        >
          <path
            fill="#ecc94b"
            d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
          />
        </svg>
        <p class="text-4xl rating-text">{{ rating }}</p>
      </div>
    </section>

    <section
      class="flex items-center justify-center py-6 flex-col md:flex-row"
      v-if="!isFirst"
    >
      <div class="flex items-center bg-gray-400 w-96 py-3 px-4">
        <i class="material-icons text-black">search</i>
        <input
          v-model="searchText"
          class="bg-gray-400 flex-grow outline-none ml-4"
          placeholder="Search"
          @input="isTyping = true"
        />
      </div>

      <button
        class="btn ml-4 mt-4 md:mt-0 py-3 px-10"
        @click="$router.push('/cops/add')"
      >
        Add New Officer Rating
      </button>
    </section>

    <div class="flex justify-center" v-if="isLoading">
      <bar-loader class="my-8" color="#4db1fa" :width="320" />
    </div>

    <section class="flex-grow w-full pb-36" v-if="!isFirst">
      <div
        class="flex items-center bg-gray-400 mt-1 h-32 px-8 py-4"
        v-for="officer in officers"
        :key="officer.id"
      >
        <img :src="`/images/avatars/${officer.emoji}.png`" class="h-16" />

        <div class="w-40 ml-4 flex-none">
          <p class="text-sm">Officer {{ officer.number }}</p>
          <p class="text-xs">{{ officer.location }}</p>
          <base-rating :value="officer.rating" readonly />
        </div>

        <p class="rating-review ml-12 text-sm flex-grow" v-line-clamp:20="4">
          {{ officer.review }}
        </p>

        <button
          class="btn ml-6 mr-4 h-12 flex-none"
          @click="
            $router.push({ name: 'add-rating', params: { id: officer.number } })
          "
        >
          Add Rating
        </button>

        <button
          class="btn btn-blue h-12 flex-none"
          @click="$router.push({ name: 'cop', params: { id: officer.number } })"
        >
          More Ratings
        </button>
      </div>
    </section>

    <base-footer class="absolute bottom-0" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import debounce from "lodash/debounce";
import OfficerService from "@/services/OfficerService";

export default {
  data() {
    return {
      officers: [],
      rating: 0,
      searchText: "",
      currentPage: 1,
      lastPage: 1,
      isFirst: true,
      isLoading: true,
      isTyping: false,
    };
  },
  computed: {
    ...mapState("profile", ["address"]),
  },
  watch: {
    searchText: debounce(function () {
      this.isTyping = false;
    }, 1000),

    currentPage: {
      immediate: true,
      async handler() {
        await this.fetch();
      },
    },

    async isTyping(value) {
      if (!value) {
        this.isLoading = true;

        if (this.currentPage === 1) {
          await this.fetch(false);
        } else {
          this.currentPage = 1;
        }
      }
    },

    async address() {
      if (this.currentPage === 1) {
        await this.fetch(false);
      } else {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    async fetch(append = true) {
      const {
        data: { data, rating, meta },
      } = await OfficerService.fetch({
        params: {
          q: this.searchText,
          page: this.currentPage,
          location: this.address,
        },
      });

      this.officers = append ? this.officers.concat(data) : data;
      this.rating = rating;
      this.lastPage = (meta || {}).last_page;

      if (this.isFirst) {
        this.isFirst = false;
      }

      this.isLoading = false;
    },

    nextPage() {
      if (this.currentPage === this.lastPage) {
        return;
      }
      this.currentPage++;
    },
  },
  created() {
    this.$parent.$on("scroll_ended", this.nextPage);
  },
};
</script>

<style lang="scss" scoped>
.rating-review {
  display: none;
  height: 82px;

  @media (min-width: 768px) {
    display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox; /* TWEENER - IE 10 */
    display: -webkit-flex; /* NEW - Chrome */
    display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  }
}

.rating-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
